import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      const { token, user } = response.data;
      
      onLogin(token, user);
      toast.success('¡Bienvenido!');
      navigate('/catalog');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center space-y-4 mb-2">
            <div className="flex items-center gap-4">
              <img src="/sudeporte-logo.png" alt="Sudeporte" className="h-12" />
              <span className="h-10 w-px bg-neutral-300" />
              <img src="/macron-msh-pos-h44.png" alt="Macron Sports Hub" className="h-10" />
            </div>
            <p className="text-xs uppercase tracking-widest text-neutral-500 mt-3">
              Elda Unión CF · Temporada 26/27
            </p>
          </Link>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-neutral-200 p-8">
          <h2 className="text-2xl font-black text-black mb-6">Iniciar sesión</h2>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                className="mt-1 border-neutral-300 focus:border-black focus:ring-black"
                placeholder="tu@email.com"
              />
            </div>

            <div>
              <div className="flex items-center justify-between mb-1">
                <Label htmlFor="password">Contraseña</Label>
                <Link to="/forgot-password" className="text-sm text-neutral-600 hover:text-black underline">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                className="mt-1 border-neutral-300 focus:border-black focus:ring-black"
                placeholder="••••••••"
              />
            </div>

            <Button 
              data-testid="login-submit-btn"
              type="submit" 
              className="w-full bg-black hover:bg-neutral-800 text-white font-bold" 
              disabled={loading}
            >
              {loading ? 'Accediendo…' : 'Acceder'}
            </Button>
          </form>
        </div>

        <div className="mt-4 text-center">
          <Link to="/" className="text-neutral-600 hover:text-black text-sm">
            ← Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
